module.exports = __webpack_public_path__ + "img/faq4.a28d6e99.png";